var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpot = function SvgSpot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.334 5a6.668 6.668 0 0 1 0 13.333A6.667 6.667 0 0 1 8.334 5m-2.356 6.667 2.357 2.356 2.356-2.356L8.335 9.31zM12.499.833a6.667 6.667 0 0 1 4.093 11.927q.072-.537.074-1.094a8.334 8.334 0 0 0-9.427-8.26A6.65 6.65 0 0 1 12.5.833"
  })));
};
export default SvgSpot;